module.exports = __webpack_public_path__ + "media/images/icon__point--gained@3x-aec92d3c369dfbb34619f4d766ded04a.png";